import styled from 'styled-components'
// @ts-ignore
import SelectField from 'react-select'
import { colors } from 'Styled/variables'

const matchColor = (percent: number) => {
  if (percent > 80) return colors.green
  if (percent > 50) return colors.messegesYellow1
  return colors.messegesRed
}

export const Select = styled(SelectField)<{ fill?: boolean }>`
  margin-bottom: 16px;
  flex: 1;
  font-family: 'Segoe UI';

  @media (max-width: 576px) {
    margin-right: 0;
    margin-bottom: 8px;
    width: 100%;
  }

  .select-playlist__control {
    display: flex;
    align-items: center;
    height: 62px;
    border: 1px solid ${colors.greyStroke};
    border-radius: 8px;
  }
  .select-playlist__input {
    display: flex;
    align-items: center;
  }
  .select-playlist__single-value {
    padding: 0 2px;
    width: 100%;

    div {
      border: none !important;
    }
  }
  .select-playlist__value-container--has-value {
    height: 100%;
  }
  .select-playlist__indicator-separator {
    margin: 0;
    background-color: ${colors.greyStroke};
  }
  .select-playlist__indicator {
    padding: 12px;
  }
  .select-playlist__control--is-focused {
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
    border: 1px solid ${colors.greyTextBlackBg};

    &:hover {
      border: 1px solid ${colors.greyTextBlackBg};
    }
  }
  .select-playlist__menu-list {
    padding: 8px 13px;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.25);
    border: none;
    border-radius: 8px;
  }
  .select-playlist__option {
    display: flex;
    align-items: center;
    height: 62px;
    padding: 13px 0;
    background-color: ${colors.white};
    cursor: pointer;

    &:last-child {
      border-bottom: none;
    }
  }
`

export const SelectOption = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  &:last-child {
    border-bottom: none;
  }
`

export const RejectOption = styled(SelectOption)`
  padding: 17.5px 0;
  border-top: 1px solid ${colors.greyBlue};
`

export const RejectOptionLabel = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: ${colors.mainText};
`

export const SelectOptionPlaylist = styled.div`
  display: flex;
  align-items: center;
  margin-right: 8px;
`

export const SelectOptionPlaylistCover = styled.img`
  margin-right: 16px;
  width: 40px;
  height: 40px;
  border-radius: 4px;
`

export const SelectOptionPlaylistInfo = styled.div`
  display: flex;
  flex-direction: column;
`

export const SelectOptionPlaylistTitle = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${colors.mainText};
`

export const SelectOptionPlaylistScore = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: ${colors.mainText};
`

export const SelectOptionPlaylistScoreLabel = styled.span`
  margin-right: 4px;
  font-size: 14px;
  font-weight: 400;
  color: ${colors.greyTextWhiteBg};
`

export const SelectOptionPercents = styled.span<{ percent: number }>`
  display: flex;
  align-items: center;
  margin-right: 8px;
  color: ${({ percent }) => matchColor(percent)};
`
